import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { initSentry } from "@/lib/sentry";
import { routeTree } from "./routeTree.gen";

export const createRouter = () => {
	const router = createTanstackRouter({
		routeTree,
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
	});

	initSentry(router);

	return router;
};

export const getRouter = () => createRouter();

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createRouter>;
	}
}
